<template>
  <div class="ioRecord" v-loading="loading">
    <div class="right">
      <!-- 搜索框 -->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for="couponName">优惠券名称:</label>
            <el-input v-model="search.couponName" placeholder="请输入优惠券名称"></el-input>
          </div>
          <div class="form-group">
            <label for="merchantName">商家名称:</label>
            <el-input v-model="search.merchantName" placeholder="请输入商家名称"></el-input>
          </div>
            <div class="form-group">
            <label for="couponName">优惠券状态:</label>
            <el-select v-model="search.status" placeholder="请选择优惠券状态"> 
              <el-option label="全部" value=""></el-option>
              <el-option label="未使用" value="1"></el-option>
              <el-option label="已使用" value="2"></el-option>
              <el-option label="已过期" value="3"></el-option>
            </el-select>
          </div>
          <!-- <div class="form-group">
            <label for="userPhone">用户手机号:</label>
            <el-input v-model="search.phone" placeholder="请输入用户手机号"></el-input>
          </div> -->
          <div class="form-group">
            <label for="receiveTime">领取时间:</label>
            <el-date-picker
              v-model="search.receiveTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
          </div>
        </form>
      </div>
      
      <!-- 状态标签页 -->
      <!-- <div class="status-tabs">
        <el-tabs v-model="activeStatus" @tab-click="handleStatusChange">
          <el-tab-pane label="全部" name="all">
            <span slot="label">
              全部
              <el-badge :value="statusCounts.all" class="status-badge" />
            </span>
          </el-tab-pane>
          <el-tab-pane label="未使用" name="1">
            <span slot="label">
              未使用
              <el-badge :value="statusCounts.unused" class="status-badge" />
            </span>
          </el-tab-pane>
          <el-tab-pane label="已使用" name="2">
            <span slot="label">
              已使用
              <el-badge :value="statusCounts.used" class="status-badge" />
            </span>
          </el-tab-pane>
          <el-tab-pane label="已过期" name="3">
            <span slot="label">
              已过期
              <el-badge :value="statusCounts.expired" class="status-badge" />
            </span>
          </el-tab-pane>
        </el-tabs>
      </div>
       -->
      <div v-show="showList" class="list-right">
        <el-table
         
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="优惠券名称"
            prop="couponName"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="商家名称"
            prop="merchantName"
            width="120"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="优惠券类型"
            prop="couponType"
            width="100"
          >
            <template slot-scope="scope">
              <span>{{ getCouponTypeName(scope.row.discountType) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="优惠券内容"
            prop="couponContent"
            width="200"
          >
            <template slot-scope="scope">
              <span>{{ getCouponContent(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="用户手机号"
            prop="phone"
            width="120"
          >
            <!-- <template slot-scope="scope">
              <span>{{ maskPhone(scope.row.phone) }}</span>
            </template> -->
          </el-table-column>
          <!-- <el-table-column
            show-overflow-tooltip
            label="用户姓名"
            prop="userName"
            width="100"
          ></el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            label="领取时间"
            prop="accessTime"
            width="150"
          ></el-table-column>
          <!-- <el-table-column
            show-overflow-tooltip
            label="使用时间"
            prop="useTime"
            width="150"
          ></el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            label="有效期"
            prop="validPeriod"
            width="200"
          >
            <template slot-scope="scope">
              <span>{{ formatDate(scope.row.termBeginTime) }} -{{ formatDate(scope.row.termEndTime) }}</span>
            </template>
        </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="状态"
            prop="status"
            width="100"
          >
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)">
                {{ getStatusName(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="120px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="viewDetail(scope.row)"
              >
                查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        
       
      </div>
    </div>

    <!-- 详情对话框 -->
    <el-dialog
      title="领取记录详情"
      :visible.sync="showDetailDialog"
      width="600px"
      @close="closeDetailDialog"
    >
      <div v-if="currentRecord" class="detail-content">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <label>优惠券名称：</label>
              <span>{{ currentRecord.couponName }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <label>商家名称：</label>
              <span>{{ currentRecord.merchantName }}</span>
            </div>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <label>优惠券类型：</label>
              <span>{{ getCouponTypeName(currentRecord.discountType) }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <label>优惠券内容：</label>
              <span>{{ getCouponContent(currentRecord) }}</span>
            </div>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <label>用户手机号：</label>
              <span>{{currentRecord.phone }}</span>
              <!-- <span>{{ maskPhone(currentRecord.phone) }}</span> -->
            </div>
          </el-col>
          <!-- <el-col :span="12">
            <div class="detail-item">
              <label>用户姓名：</label>
              <span>{{ currentRecord.userName }}</span>
            </div>
          </el-col> -->
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <label>领取时间：</label>
              <span>{{ currentRecord.accessTime }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <label>使用时间：</label>
              <span>{{ currentRecord.userTime || '未使用' }}</span>
            </div>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <label>有效期：</label>
              <span>{{ formatDate(currentRecord.termBeginTime) }} - {{ formatDate(currentRecord.termEndTime) }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <label>状态：</label>
              <el-tag :type="getStatusType(currentRecord.status)">
                {{ getStatusName(currentRecord.status) }}
              </el-tag>
            </div>
          </el-col>
        </el-row>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDetailDialog">关 闭</el-button>
      </div>
    </el-dialog>
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Page from "@/page/commons/page";

import { shopCouponReceiveList } from "@/api/url";
export default {
  name: "receive-record",
  components: {
    Page
  },  
    computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  data() {
    return {
      loading: false,
      moduleName: "receive-record",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      tableListData: [],
      total: 0,
      showList: true,
      search: {
        pageSize: 10,
        pageNumber: 1,
        status: "",
        couponName: "",
        merchantName: "",
   
        receiveTime: []
      },
      currentRecord: null,
      showDetailDialog: false,
      
      // 状态标签页相关
      activeStatus: "all",
      statusCounts: {
        all: 0,
        unused: 0,
        used: 0,
        expired: 0
      }
    };
  },
  mounted() {
    this.tableList(1);
  },
  methods: {
    ...mapMutations(["getPage"]),
    
    // 分页数据接收
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    
    // 获取领取记录列表
    tableList(curPage) {
      this.loading = true;
      const params = {
        page: curPage,
        limit: this.search.pageSize,
        status: this.search.status,
        couponName: this.search.couponName,
        merchantName: this.search.merchantName,
        beginTime: this.search.receiveTime[0]? this.search.receiveTime[0] : '',
        endTime: this.search.receiveTime[1]? this.search.receiveTime[1] :''
        
      };
      this.$get(shopCouponReceiveList(), params)
        .then((res) => {
          this.tableListData = res.data.rows || [];
          //翻页
          var pageObj = {
            curIndex: res.data.offset,
            rowsCount: res.data.total,
          };
          this.getPage(pageObj);
        })
        .catch((error) => {
          // 如果接口失败，使用测试数据
          // this.loadTestMerchantData();
        })
        .finally(() => {
          this.loading = false;
        });
      
  
    },
    
    // // 更新状态统计
    // updateStatusCounts(allData) {
    //   this.statusCounts = {
    //     all: allData.length,
    //     unused: allData.filter(item => item.status === "1").length,
    //     used: allData.filter(item => item.status === "2").length,
    //     expired: allData.filter(item => item.status === "3").length
    //   };
    // },
    
    // 搜索
    searchList() {
      this.search.pageNumber = 1;
      this.tableList(1);
    },
    
    // 获取优惠券类型名称
    getCouponTypeName(type) {
      const typeMap = {
        1: "满减券",
        3: "折扣券",
        5: "抵扣券"
      };
      return typeMap[type] || "优惠券";
    },
    
    // 获取优惠券内容
    getCouponContent(row) {
      const { discountType, thresholdAmount, discountValue } = row;
      
      if (!thresholdAmount && !discountValue) {
        return row.couponContent || '';
      }
      
      switch (discountType) {
        case 1: // 满减券
          return `满${thresholdAmount}元，减${discountValue}元`;
        case 3: // 折扣券
          return `满${thresholdAmount}元，打${discountValue}折`;
        case 5: // 代金券
          return `满${thresholdAmount}元，${discountValue}元`;
        default:
          return row.couponContent || '';
      }
    },
    
    // 获取状态名称
    getStatusName(status) {
      const statusMap = {
        "1": "未使用",
        "2": "已使用",
        "3": "已过期"
      };
      return statusMap[status] || "未知";
    },
    
    // 获取状态类型
    getStatusType(status) {
      const typeMap = {
        "1": "info",
        "2": "success",
        "3": "warning"
      };
      return typeMap[status] || "info";
    },
    
    // 状态标签页切换
    handleStatusChange(tab) {
      this.search.status = tab.name === "all" ? "" : tab.name;
      this.search.pageNumber = 1;
      this.tableList(1);
    },
    
    // 查看详情
    viewDetail(row) {
      this.currentRecord = row;
      this.showDetailDialog = true;
    },
    
    // 关闭详情对话框
    closeDetailDialog() {
      this.showDetailDialog = false;
      this.currentRecord = null;
    },
    
    // 手机号脱敏处理
    maskPhone(phone) {
      if (!phone) return '';
      if (phone.length === 11) {
        // 标准11位手机号：显示前3位和后4位，中间用*代替
        return phone.substring(0, 3) + '****' + phone.substring(7);
      } else if (phone.length > 4) {
        // 其他长度的手机号：显示前2位和后2位，中间用*代替
        const start = phone.substring(0, 2);
        const end = phone.substring(phone.length - 2);
        const middle = '*'.repeat(phone.length - 4);
        return start + middle + end;
      }
      return phone;
    },
    
    // 格式化日期，去掉时分秒
    formatDate(dateStr) {
      if (!dateStr) return '';
      // 如果包含时间部分，只取日期部分
      if (dateStr.includes(' ')) {
        return dateStr.split(' ')[0];
      }
      // 如果包含T（ISO格式），只取日期部分
      if (dateStr.includes('T')) {
        return dateStr.split('T')[0];
      }
      return dateStr;
    }
  }
};
</script>

<style scoped>
.el-tag {
  margin: 0;
}

/* 状态标签页样式 */
.status-tabs {
  margin-bottom: 20px;
  background: #fff;
  padding: 0 20px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.status-tabs .el-tabs__header {
  margin: 0;
  border-bottom: none !important;
}

.status-tabs .el-tabs__nav-wrap::after {
  display: none !important;
  content: none !important;
}

.status-tabs .el-tabs__nav-wrap {
  border-bottom: none !important;
}

.status-tabs .el-tabs__nav-wrap::before {
  display: none !important;
  content: none !important;
}

.status-tabs .el-tabs__active-bar {
  display: none;
}

.status-tabs .el-tabs__item {
  border-bottom: none !important;
}

.status-tabs .el-tabs__content {
  border: none !important;
}

.status-tabs .el-tabs__header::after {
  display: none !important;
  content: none !important;
}

.status-tabs .el-tabs__header::before {
  display: none !important;
  content: none !important;
}

/* 强制移除所有可能的边框 */
.status-tabs .el-tabs {
  border: none !important;
}

.status-tabs .el-tabs__header {
  border: none !important;
  border-bottom: none !important;
}

.status-tabs .el-tabs__nav {
  border: none !important;
}

.status-tabs .el-tabs__nav-wrap {
  border: none !important;
  border-bottom: none !important;
}

.status-tabs .el-tabs__nav-scroll {
  border: none !important;
}

/* 移除所有伪元素的边框 */
.status-tabs *::before,
.status-tabs *::after {
  border: none !important;
  border-bottom: none !important;
}

/* 使用深度选择器强制覆盖 */
.status-tabs >>> .el-tabs__header {
  border-bottom: none !important;
}

.status-tabs >>> .el-tabs__nav-wrap::after {
  display: none !important;
}

.status-tabs >>> .el-tabs__nav-wrap {
  border-bottom: none !important;
}

/* 如果还是不行，尝试更具体的选择器 */
.status-tabs .el-tabs__header .el-tabs__nav-wrap::after {
  display: none !important;
  content: none !important;
  border: none !important;
}

.status-badge {
  margin-left: 8px;
}

/* 详情对话框样式 */
.detail-content {
  padding: 20px 0;
}

.detail-item {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.detail-item label {
  font-weight: 600;
  color: #333;
  min-width: 100px;
  margin-right: 10px;
}

.detail-item span {
  color: #666;
  flex: 1;
}
</style>
